export default function Contact() {

    //const navigate = useNavigate();

    /*const [contact,getContact] = useState([]);
    useEffect(()=>loadContacts(getContact,navigate),[navigate])*/

    const ContactLabel = ({ text, src }) => {

        return (
            <div className="relative flex flex-row items-center">
                <div className="absolute inset-0 border border-dark-green box-content rounded-full"/>
                <img className="bg-dark-green rounded-full size-8 p-1" alt="" src={src} />
                <p className="px-4">{text}</p>
            </div>
        )
    }


    return (
        <div className="text-dark-green flex flex-col items-center gap-4 mt-8">
            <img className="h-28" alt="logo" src="../iconslimsvet/logo.png" />
            <div className="my-6">
                <p className="font-medium">Fond des Mes 5/3 Tour F</p>
                <p className="font-medium">1348 Louvain-La-Neuve</p>
            </div>

            <ContactLabel text="Secrétariat: +32.10.56.10.10" src="../iconslimsvet/phone.svg" />
            <ContactLabel text="Vétérinaires: vet@limsvet.be" src="../iconslimsvet/mail.svg" />
            <ContactLabel text="Clients: info@limsvet.be" src="../iconslimsvet/mail.svg" />
            <ContactLabel text="Facturation: facturation@limsvet.be" src="../iconslimsvet/mail.svg" />
        </div>
    );
}